import { ToolTip as ImportToolTip } from '@trp-innersource/react-communication';
import classNames from 'classnames';
import React from 'react';
import defaultPic from 'src/assets/images/icon_help.svg';
import { PopUpPosition } from 'src/types';
import styles from './ToolTip.module.scss';

export interface ToolTipProps {
  callerText?: JSX.Element | string;
  header?: JSX.Element | string;
  id?: string;
  maxNoteWidth?: string;
  message: JSX.Element | string;
  popOutPlacement?: PopUpPosition;
  theme?: string;
  headerClass?: string;
  bodyClass?: string;
  showBottomBorder?: boolean;
}

export type ToolTipDescriptionProps = Pick<
  ToolTipProps,
  'header' | 'theme' | 'headerClass' | 'bodyClass'
>;
let toolTipCounter = 0;
const ToolTipDescription: React.FC<ToolTipDescriptionProps> = ({
  header,
  children,
  theme,
  headerClass,
  bodyClass,
}) => (
  <div>
    {!!header && (
      <span
        className={classNames(
          styles['tooltip-header'],
          {
            [styles.dark]: theme === 'dark',
          },
          headerClass
        )}
        data-testid="tooltip-header"
      >
        {header}
      </span>
    )}
    <span
      className={classNames(
        styles['tooltip-body'],
        styles['e2e-tooltip-body'],
        {
          [styles.dark]: theme === 'dark',
        },
        bodyClass
      )}
      data-testid="tooltip-message"
    >
      {children}
    </span>
  </div>
);

const ToolTip: React.VFC<ToolTipProps> = ({
  callerText,
  header,
  id,
  maxNoteWidth = '285px',
  message,
  popOutPlacement = PopUpPosition.TOP,
  theme = '',
  headerClass = '',
  bodyClass = '',
  showBottomBorder = true,
}) => {
  const toolTipNumber = ++toolTipCounter;
  const callerNode = callerText ? (
    <span
      className={classNames(
        showBottomBorder && styles['trigger-text'],
        styles['tool-tip-trigger'],
        showBottomBorder && 'trigger-text',
        'e2e-tool-tip',
        theme
      )}
      data-testid="tool-tip-caller-text"
    >
      {callerText}
    </span>
  ) : (
    <div
      className={classNames(
        styles['trigger-img'],
        styles['tool-tip-trigger'],
        'e2e-tool-tip',
        theme
      )}
    >
      <img alt="help" className={styles['tool-tip-image']} src={defaultPic} />
    </div>
  );
  // @ts
  return (
    <React.Fragment>
      <ImportToolTip
        {...{ callerNode, maxNoteWidth, popOutPlacement }}
        description={
          <ToolTipDescription
            bodyClass={bodyClass}
            header={header}
            headerClass={headerClass}
            theme={theme}
          >
            {message}
          </ToolTipDescription>
        }
        id={id ?? `tooltip-${toolTipNumber}`}
      />
    </React.Fragment>
  );
};

export default ToolTip;
